import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import InputPeople from "./InputPeople"
import { useTour } from "@/hooks/tour/useTour"
import { useMemo } from "react"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useTranslation } from "react-i18next"
import _ from "lodash"

const InputInf = () => {

  const inputChd = useAppSelector(state => state.tour.inputTour.inputInf)
  const selectedDepartureSchedule = useAppSelector(state => state.tour.inputTour.selectedDepartureSchedule)
  const { tour: { data: tour } } = useTour()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const priceInf = useMemo(() => {
    if (!selectedDepartureSchedule) {
      return 0
    }
    const departureSchedule: any = tour?.departureSchedule?.find(d => d.id === selectedDepartureSchedule)
    return departureSchedule?.prices[0]?.priceInf
  }, [selectedDepartureSchedule, tour?.departureSchedule])

  return (
    <InputPeople
      label={`${t("common.infant")}`}
      subLabel={`< ${tour.agesInfant} ${_.lowerFirst(t("common.years_old"))}`}
      value={inputChd}
      price={priceInf}
      onChange={(val) => dispatch(tourActions.inputPeople({ type: 'INF', value: val }))}
    />
  )
}

export default InputInf